/* ds-facet-siblings.js — мобильная кнопка «Раскрыть» у соседних значений
   параметра (sections/ds-facet-siblings.liquid). Свёрнуто: две строки с
   прокруткой (CSS); раскрыто: перенос. Кнопка скрывается, если пилюли и так
   влезли без прокрутки. Идемпотентно для редактора темы. */
(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('[data-facet-siblings]').forEach(function (section) {
      if (section.dataset.facetSiblingsInit) return;
      section.dataset.facetSiblingsInit = 'true';
      var toggle = section.querySelector('[data-facet-siblings-toggle]');
      var pills = section.querySelector('[data-facet-siblings-pills]');
      if (!toggle || !pills) return;
      var label = toggle.querySelector('[data-facet-siblings-toggle-label]');

      function overflowing() {
        return pills.scrollWidth > pills.clientWidth + 2;
      }

      function sync() {
        var expanded = pills.classList.contains('is-expanded');
        toggle.hidden = !expanded && !overflowing();
      }

      toggle.addEventListener('click', function () {
        var expanded = pills.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) label.textContent = expanded ? toggle.dataset.labelCollapse : toggle.dataset.labelExpand;
        if (!expanded) pills.scrollLeft = 0;
      });

      sync();
      window.addEventListener('resize', sync);
    });
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
